export default __webpack_public_path__ + "static/media/Mobilab logo.508df388.png";